import { render, staticRenderFns } from "./InsuranceDocuments.vue?vue&type=template&id=3b07a0e9&scoped=true"
import script from "./InsuranceDocuments.vue?vue&type=script&lang=js"
export * from "./InsuranceDocuments.vue?vue&type=script&lang=js"
import style0 from "./InsuranceDocuments.vue?vue&type=style&index=0&id=3b07a0e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07a0e9",
  null
  
)

export default component.exports